module.exports = __webpack_public_path__ + "media/images/pages/ai/icon-visual-775394d0fdc8524003e43574482f5e67.svg";